import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DEFAULT_LANG_REDIRECTOR_CUSTOM_COUNTRY_LANG_MAP: DiToken<Record<string, string>> = new DiToken<
  Record<string, string>
>('defaultLangRedirectorCustomCountryLangMap', {
  factory: () => ({})
});
